import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplyFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11 14.329C15.594 14.329 19.499 16.692 21 20V18.993C21 12.977 16.579 8.07 11 7.702V3L3 11L11 19V14.333",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11 13.579C10.5858 13.579 10.25 13.9148 10.25 14.329C10.25 14.7432 10.5858 15.079 11 15.079V13.579ZM21 20L20.317 20.3099C20.4629 20.6315 20.8134 20.8077 21.1585 20.7331C21.5037 20.6584 21.75 20.3531 21.75 20H21ZM11 7.702H10.25C10.25 8.09705 10.5564 8.42437 10.9506 8.45037L11 7.702ZM11 3H11.75C11.75 2.69665 11.5673 2.42318 11.287 2.30709C11.0068 2.191 10.6842 2.25517 10.4697 2.46967L11 3ZM3 11L2.46967 10.4697C2.17678 10.7626 2.17678 11.2374 2.46967 11.5303L3 11ZM11 19L10.4697 19.5303C10.6842 19.7448 11.0068 19.809 11.287 19.6929C11.5673 19.5768 11.75 19.3033 11.75 19H11ZM11.75 14.333C11.75 13.9188 11.4142 13.583 11 13.583C10.5858 13.583 10.25 13.9188 10.25 14.333H11.75ZM11 15.079C15.3596 15.079 18.9606 17.3204 20.317 20.3099L21.683 19.6901C20.0374 16.0636 15.8284 13.579 11 13.579V15.079ZM21.75 20V18.993H20.25V20H21.75ZM21.75 18.993C21.75 12.6167 17.0563 7.34985 11.0494 6.95363L10.9506 8.45037C16.1017 8.79014 20.25 13.3373 20.25 18.993H21.75ZM11.75 7.702V3H10.25V7.702H11.75ZM10.4697 2.46967L2.46967 10.4697L3.53033 11.5303L11.5303 3.53033L10.4697 2.46967ZM2.46967 11.5303L10.4697 19.5303L11.5303 18.4697L3.53033 10.4697L2.46967 11.5303ZM11.75 19V14.333H10.25V19H11.75Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgReplyFilled);
export default ForwardRef;
